import React from "react";
import "./UpdateFieldsFormFailedAICard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";

export const UpdateFieldsFormFailedAICard = ({ message, onActionClick }) => {
  const now = new Date();
  const day = now.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = now.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

  const validationErrors = message.validationErrors || [];

  return (
    <div className={`order-chat-bubble ${message.role}`}>
      <div className="order-ai-card update-fields-form-failed-card">
        <div className="order-ai-card-header">
          <div className="order-ai-card-title-logo">
            <img
              src={aiChatlogo}
              alt="LOGO"
              aria-hidden="true"
              className="order-ai-logo"
              style={{ width: 32, height: 32 }}
            />
          </div>
          <div className="order-ai-card-title-Avatar">
            <span>{message.header?.title || "Axon AI"}</span>
            <div className="order-ai-card-time">{`${day} ${time}`}</div>
          </div>
        </div>

        <div className="order-ai-card-body">
          <div className="update-fields-form-failed-container">
            <div className="failed-icon-wrapper">
              <span className="warning-icon">⚠️</span>
              <span className="failed-text">Failed to update the value.</span>
            </div>

            <div className="failed-message">
              {validationErrors.map((error, idx) => (
                <p key={idx}>
                  {error.fieldLabel}: {error.error}
                </p>
              ))}
            </div>

            <div className="failed-instruction">
              <p>
                Please correct the values and try again by sending "Action Taken".
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
